import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-work',
  templateUrl: './work.component.html',
  styleUrls: ['./work.component.css']
})
export class WorkComponent implements OnInit {

  images: any[]
  constructor(private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle("Lejdi Prifti - Work")
    this.images = [];
    this.images.push({source:'assets/images/carRentalGalleria/login.jpg', alt:'The front page for users to login', title:'Login'});
    this.images.push({source:'assets/images/carRentalGalleria/adminDashboard.jpg', alt:'After login, the administator is presented with live statistics.', title:'Admin Dashboard'});
    this.images.push({source:'assets/images/carRentalGalleria/listOfReservations.jpg', alt:'The list of all reservations that have been done.', title:'Reservations\' List'});
    this.images.push({source:'assets/images/carRentalGalleria/adminCars.jpg', alt:'The admin can check all the cars that are at his car rental center.', title:'Admin Cars'});
    this.images.push({source:'assets/images/carRentalGalleria/carDetails.jpg', alt:'By clicking details, you can view the car details.', title:'Car Details'});
    this.images.push({source:'assets/images/carRentalGalleria/Categories.jpg', alt:'All cars/vehicles are organized into categories.', title:'Categories'});
    this.images.push({source:'assets/images/carRentalGalleria/clientDashboard.jpg', alt:'After login, the client can view the cars that are available for rent.', title:'Client Dashboard'});
    this.images.push({source:'assets/images/carRentalGalleria/clientReservations.jpg', alt:'Client can check his/her list of all-time reservations.', title:'Client Reservations'});
    this.images.push({source:'assets/images/carRentalGalleria/reservation.jpg', alt:'Client chooses time and date of pick-up and drop-off.', title:'Client Booking'});
    this.images.push({source:'assets/images/carRentalGalleria/feeCalculated.jpg', alt:'After both pick-up and drop-off time have been chosen, the fee is calculated.', title:'Fee Calculation'});
    this.images.push({source:'assets/images/carRentalGalleria/ReservationDetails.jpg', alt:'You can edit your reservation as long as the pick-up time has not passed.', title:'Reservation Edit'});
    this.images.push({source:'assets/images/carRentalGalleria/userDetails.jpg', alt:'User can edit his/her details at any time, expect his/her username which is unique.', title:'User Details'});
    this.images.push({source:'assets/images/carRentalGalleria/CarAdd.jpg', alt:'Form used by the administrator to add a new car.', title:'New Car'});
  }

}
